"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "morra-de-sanctis": {
    "961eaf46": [{
      "hkey": "9118ef6e",
      "slug": "morra-de-sanctis",
      "name": "Morra De Sanctis",
      "primary": true,
      "skipSearch": false
    }],
    "cervino": [{
      "hkey": "9118ef6e",
      "slug": "morra-de-sanctis",
      "name": "Morra De Sanctis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49920120": [{
      "hkey": "9118ef6e",
      "slug": "morra-de-sanctis",
      "name": "Morra De Sanctis",
      "primary": true,
      "skipSearch": false
    }],
    "chiancheroni": [{
      "hkey": "9118ef6e",
      "slug": "morra-de-sanctis",
      "name": "Morra De Sanctis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25301778": [{
      "hkey": "9118ef6e",
      "slug": "morra-de-sanctis",
      "name": "Morra De Sanctis",
      "primary": true,
      "skipSearch": false
    }],
    "orcomone": [{
      "hkey": "9118ef6e",
      "slug": "morra-de-sanctis",
      "name": "Morra De Sanctis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7923a9f8": [{
      "hkey": "9118ef6e",
      "slug": "morra-de-sanctis",
      "name": "Morra De Sanctis",
      "primary": true,
      "skipSearch": false
    }],
    "selvapiana": [{
      "hkey": "9118ef6e",
      "slug": "morra-de-sanctis",
      "name": "Morra De Sanctis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;